module.exports = __webpack_public_path__ + "static/media/phone.5950874f.svg";